import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GeneralService } from './general.service';
@Injectable()
export class CompanyDetailsService {
  public x;
  constructor (private http: HttpClient, private general: GeneralService) { }
  // getDetails(){
  //   this.x = [
  //     {"id":1, "name":"", "color":"#2E3091","logo":"assets/images/scit-logo.png"},
  //     {"id":2, "name":"NBTS", "color":"green","logo":"assets/images/scct-logo.png"},
  //     {"id":3, "name":"MIT", "color":"#2E3091","logo":""}
  //   ];
  //   return this.x[0];
  // }
  getDetails () {
    return this.general.requestWithCache(
      this.http.get<any>('/edozzier/portal-company-details.php'),
      { data: "company_details" }
    );
  }

  getBaseUrl () {
    let url = window.location.href;
    let arr = url.split("/");
    let baseUrl = arr[0] + "//" + arr[2] + '/';
    return baseUrl
    //return "https://nbts.edu.ng/";
  }


}
